import {useTheme} from "@emotion/react"
import {Box, Link, Typography} from "@mui/material"
import React from "react"
import InfoIcon from "../../components/general/infoIcon"

export const widgetLinkPrototype = [
    {
        key: "textAlignment",
        type: "SELECT",
        label: "Text Positionierung",
        size: 3,
        options: [
            {
                value: "LEFT",
                label: "Links",
            },
            {
                value: "RIGHT",
                label: "Rechts",
            },
            {
                value: "CENTER",
                label: "Mittig",
            },
        ],
    },
    {
        key: "fontWeight",
        type: "SELECT",
        label: "Font weight",
        size: 3,
        options: [
            {
                value: "100",
                label: "100",
            },
            {
                value: "200",
                label: "200",
            },
            {
                value: "300",
                label: "300",
            },
            {
                value: "400",
                label: "400",
            },
            {
                value: "500",
                label: "500",
            },
            {
                value: "600",
                label: "600",
            },
            {
                value: "700",
                label: "700",
            },
            {
                value: "800",
                label: "800",
            },
            {
                value: "900",
                label: "900",
            },
        ],
    },
    {
        key: "fontSize",
        type: "INTEGER",
        label: "Font Size in px",
        size: 3,
    },
    {
        key: "lineHeight",
        type: "INTEGER",
        label: "Line Height in px",
        size: 3,
    },
    {
        key: "infotext",
        type: "STRING",
        label: "infotext",
        size: 6,
    },
    {
        key: "textElement",
        type: "SELECTTREE",
        label: "Textbaustein",
        size: 6,
        options: "text",
    },
]

const getTextFromTextElement = (textElement) => {
    const tenant = window._env_.THEME
    return textElement.type === "innerNode"
        ? textElement.children.find((child) => child.label === tenant)?.text
        : textElement.text
}

const WidgetLink = ({widget, error}) => {
    const theme = useTheme()
    const {fontSize, lineHeight} = widget
    const errorState = error ? {color: theme.LINKWIDGET.errorColor} : {}
    const textElement = widget.textElement?.origin
    const displayValue = textElement
        ? getTextFromTextElement(textElement)
        : widget.text

    return (
        <Box
            width="100%"
            display="flex"
            alignItems="center"
            flexDirection="column">
            <Typography
                align={widget.textAlignment}
                sx={{
                    width: "100%",
                    whiteSpace: "pre-line",
                    ...errorState,
                }}
                {...(fontSize && {fontSize: `${fontSize}px`})}
                {...(lineHeight && {lineHeight: `${lineHeight}px`})}
                component={widget.tag}
                variant={widget.tag}
                fontWeight={widget.fontWeight ?? "400"}>
                <Link
                    href={displayValue}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover">
                    {widget.text}
                </Link>
                {widget.infotext && (
                    <InfoIcon
                        infoText={widget.infotext}
                        color={widget.color}
                    />
                )}
            </Typography>
            {widget.subtext && (
                <Typography
                    align={widget.textAlignment}
                    sx={{
                        width: "100%",
                        whiteSpace: "pre-line",
                        color: widget.color ?? "",
                        ...errorState,
                    }}
                    fontWeight="600">
                    {widget.subtext}
                </Typography>
            )}
        </Box>
    )
}

export default WidgetLink
